<a class="show-for-country-page" (click)="addDocument()">Add Document</a>
<button class="show-for-document-page" mat-flat-button (click)="addDocument()" color="accent">Add Document</button>
